import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appServices } from '@/data/AppServices';
import type { MasteryFilter, Vocabulary } from '@/domain/Models';

const FILTERS: Array<{ id: MasteryFilter; label: string }> = [
  { id: 'ALL', label: '全部' },
  { id: 'NEW', label: '未学' },
  { id: 'LEARNING', label: '学习中' },
  { id: 'MASTERED', label: '已掌握' },
  { id: 'DUE', label: '到期' },
  { id: 'FAVORITE', label: '收藏' },
];

export function VocabularyListPage() {
  const [query, setQuery] = useState('');
  const [mastery, setMastery] = useState<MasteryFilter>('ALL');
  const [words, setWords] = useState<Vocabulary[]>([]);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const reload = useCallback(async () => {
    try {
      const list = await appServices.vocabulary.list(query, mastery === 'FAVORITE');
      setWords(list);
      setError(null);
    } catch (e) {
      setError(String(e));
    }
  }, [query, mastery]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return (
    <div className="page stack">
      <button type="button" onClick={() => navigate('/vocabulary/practice')}>
        开始背单词
      </button>
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="搜索单词 / 释义"
        aria-label="搜索单词或释义"
      />
      <div className="row" style={{ flexWrap: 'wrap', gap: 6 }}>
        {FILTERS.map((f) => (
          <button
            key={f.id}
            type="button"
            className={mastery === f.id ? undefined : 'secondary'}
            onClick={() => setMastery(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>
      {error && <div className="error-box">{error}</div>}
      {words.map((w) => (
        <section key={w.id} className="card stack">
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <strong>{w.term}</strong>
            {w.itemKind === 'PHRASE' && <span className="muted">短语</span>}
          </div>
          <div>{w.chineseGloss}</div>
        </section>
      ))}
      {words.length === 0 && <div className="muted">没有匹配的词条</div>}
    </div>
  );
}
